<div class='container'>
  <h2>Register</h2>
  <form [formGroup]='registerForm' (ngSubmit)='onSubmit()'>
    <div class='form-group'>
      <label for='displayName'>Display name</label>
      <input type='text' formControlName='displayName' id='displayName' class='form-control'
             [ngClass]="{ 'is-invalid': submitted && f.displayName.errors }"/>
      <div *ngIf='submitted && f.displayName.errors' class='invalid-feedback'>
        <div *ngIf='f.displayName.errors.required'>Display name is required</div>
      </div>
    </div>
    <div class='form-group'>
      <label for='email'>Email</label>
      <input type='email' formControlName='email' id='email' class='form-control'
             [ngClass]="{ 'is-invalid': submitted && f.email.errors }"/>
      <div *ngIf='submitted && f.email.errors' class='invalid-feedback'>
        <div *ngIf='f.email.errors.required'>Email is required</div>
        <div *ngIf='f.email.errors.pattern'>Email is invalid</div>
      </div>
    </div>
    <div class='form-group'>
      <label for='password'>Password</label>
      <input type='password' formControlName='password' id='password' class='form-control'
             [ngClass]="{ 'is-invalid': submitted && f.password.errors }"/>
      <div *ngIf='submitted && f.password.errors' class='invalid-feedback'>
        <div *ngIf='f.password.errors.required'>Password is required</div>
        <div *ngIf='f.password.errors.minlength'>Password must be at least 6 characters</div>
      </div>
    </div>
    <div class='form-group'>
      <button [disabled]='loading' class='btn btn-primary'>
        <span *ngIf='loading' class='spinner-border spinner-border-sm mr-1'></span>
        Register
      </button>
      <a routerLink='/' class='btn btn-link'>Cancel</a>
    </div>
  </form>
</div>
